import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/teax.jpg";
import "../style/styles.css";
import "../style/Teasof.css";

const TeaSof = () => {
  const quickStats = [
    { value: "ERP", label: "Tea Garden Management" },
    { value: "Android", label: "Attendance App" },
    { value: "Wages", label: "Worker Payroll" },
    { value: "Stock", label: "Inventory Control" },
  ];

  const coreModules = [
    {
      title: "Worker Wages",
      text:
        "Manage casual, permanent and contractual worker attendance, wage sheets, payment statements, wage slips, Kamjari, ration, deductions, PF, bonus and leave registers.",
    },
    {
      title: "Employee Salary",
      text:
        "Handle staff and sub-staff attendance, pay register, pay slip, ration sheet, PF register, professional tax, leave, arrear and bonus reports.",
    },
    {
      title: "Inventory Control",
      text:
        "Track company, division and product-wise stock status, product stock summary, maximum/minimum label, slow-moving stock and high-value stock.",
    },
    {
      title: "Purchase Analysis",
      text:
        "Analyze product, group, company, supplier and division-wise purchases with indent register, purchase order register and pending purchase order reports.",
    },
    {
      title: "Consumption Analysis",
      text:
        "Monitor product, division, department, section, SOE, purpose and date-wise consumption for better estate cost control.",
    },
    {
      title: "Garden Accounting",
      text:
        "Generate cash bank book, journal book, purchase register, SOE ledger, cost centre ledger, monthly expenditure, outstanding and trial balance reports.",
    },
  ];

  const wagesFeatures = [
    "Worker Attendance - Casual, Permanent & Contractual",
    "Wage Sheet and Summary Wage",
    "Payment Statement - Worker A/c No Wise",
    "Cash Payment Register for Other Works",
    "Worker Wage Slip",
    "Daily Kamjari and Worker Wise Kamjari",
    "Monthly / Yearly / Abstract Kamjari",
    "Division Wise Kamjari Register",
    "Green Leaf and Man Power Register",
    "Ration Register",
    "Electric and LIC Deduction / Non-Recovery",
    "Monthly / Quarterly PF Statement",
    "PF Form 3A & 6A",
    "ECR Challan Generate",
    "Absent Analysis",
    "Arrear Payment Sheet",
    "Annual Leave Register",
    "Bonus Statement",
    "Incentive & Pro-rata as per Tea Board Rules",
  ];

  const salaryFeatures = [
    "Worker Attendance - Casual and Permanent",
    "Attendance Check List",
    "Pay Register - Staff / Sub-Staff",
    "Pay Slip",
    "Ration Sheet",
    "Staff & Sub-Staff PF Register",
    "Professional Tax Register",
    "Annual Leave Register",
    "Arrear Pay Register",
    "LIC and Other Deduction Register",
    "Bonus Register",
  ];

  const stockFeatures = [
    "Company-Division-Product Wise Stock Status",
    "Product Wise Stock Summary",
    "Maximum and Minimum Label Register",
    "Slow Moving Product Stock Summary",
    "High Value Product Stock Summary",
  ];

  const purchaseFeatures = [
    "Product-Group / Company-Month Wise Purchase",
    "Division / Sub-Group Monthly Purchase",
    "Purchase Query",
    "Cumulative Analysis of Purchase",
    "Company / Group Wise Purchase - Date and Month Wise",
    "Company / Group Wise Purchase - Y2K Analysis",
    "Product Analysis of Purchase",
    "Supplier-Product-Division Wise Purchase Analysis",
    "Supplier-Product-Division Wise Monthly Purchase Analysis",
    "Indent Register and Voucher Print",
    "Purchase Order Register",
    "Pending Purchase Order Register",
  ];

  const consumptionFeatures = [
    "Product-Group / Company-Month Consumption",
    "Division / Sub-Group Monthly Consumption",
    "Issue / Consumption Query",
    "Division Wise Consumption",
    "Purpose and Division Wise Consumption",
    "Purpose Wise Consumption",
    "SOE Wise Consumption",
    "Date Wise Consumption",
    "Department Wise Consumption",
    "Section Wise Consumption",
    "SOE-Purpose Wise Consumption",
    "Product Wise Consumption",
  ];

  const accountingFeatures = [
    "Cash Bank Book",
    "Journal Book",
    "Purchase Register",
    "Purchase Return Register",
    "SOE Ledger with Cost Centre Analysis",
    "Ledger",
    "Ledger Summary",
    "SOE Report",
    "Cost Centre Ledger",
    "Accounts Group Wise Reports",
    "Monthly Expenditure Statement",
    "Party Wise Outstanding - Bill by Bill",
    "Trial Balance - Group / Normal / Alphabetically",
  ];

  const seoKeywords = [
    "Tea Garden Management Software",
    "Tea Garden ERP Software",
    "Tea Estate ERP Software",
    "Tea Plantation Management Software",
    "Tea Garden Payroll Software",
    "Tea Estate Payroll Software",
    "Worker Wage Management Software",
    "Tea Garden Worker Wages",
    "Kamjari Management Software",
    "Tea Garden Attendance Software",
    "Android Attendance App for Tea Garden",
    "Tea Garden Worker Attendance App",
    "Tea Garden Employee Attendance App",
    "Plucking Weighment Software",
    "Green Leaf Weighment Software",
    "Weight Machine Integration Software",
    "Tea Garden Inventory Software",
    "Tea Estate Stock Management Software",
    "Tea Garden Purchase Management Software",
    "Indent Register Software",
    "Purchase Order Management Software",
    "Tea Garden Consumption Analysis",
    "Tea Estate Consumption Management",
    "Garden Accounting Software",
    "Tea Estate Accounting Software",
    "SOE Ledger Software",
    "Cost Centre Ledger Software",
    "PF ECR Challan Software",
    "Tea Garden PF Register",
    "Worker Wage Slip Software",
    "Staff Salary Software",
    "Tea Garden Bonus Register",
    "Tea Garden Ration Register",
    "Tea Garden Leave Register",
    "Tea Garden ERP in India",
    "Tea Estate Software in India",
    "North Bengal Tea Garden Software",
    "Darjeeling Tea Garden Software",
    "Assam Tea Garden Software",
  ];

  const relatedSearchGroups = [
    {
      title: "Tea Garden ERP & Estate Management",
      text:
        "TeaSof supports tea gardens, tea estates and tea plantations with complete ERP tools for daily garden operation, estate reporting, worker management and administration.",
      terms: [
        "Tea Garden Management Software",
        "Tea Garden ERP Software",
        "Tea Estate ERP Software",
        "Tea Plantation Management Software",
        "Tea Estate Management Software",
        "Tea Garden Software",
        "Tea Estate Software",
        "Tea Garden ERP in India",
        "Tea Estate Software in India",
        "North Bengal Tea Garden Software",
        "Darjeeling Tea Garden Software",
        "Assam Tea Garden Software",
      ],
    },
    {
      title: "Worker Wages, Kamjari & Payroll",
      text:
        "TeaSof manages tea garden worker wages, Kamjari, wage slips, PF, bonus, ration, arrear, leave and staff salary reports for better payroll control.",
      terms: [
        "Tea Garden Payroll Software",
        "Tea Estate Payroll Software",
        "Worker Wage Management Software",
        "Tea Garden Worker Wages",
        "Kamjari Management Software",
        "Daily Kamjari Software",
        "Worker Wise Kamjari Register",
        "Division Wise Kamjari Register",
        "Worker Wage Slip Software",
        "Tea Garden PF Register",
        "PF ECR Challan Software",
        "Tea Garden Bonus Register",
        "Tea Garden Ration Register",
        "Tea Garden Leave Register",
        "Staff Salary Software",
        "Tea Garden Staff Salary Software",
      ],
    },
    {
      title: "Attendance, Weighment & Field Automation",
      text:
        "TeaSof provides Android attendance and plucking weighment support for field-level data accuracy, worker attendance, employee attendance and green leaf operations.",
      terms: [
        "Tea Garden Attendance Software",
        "Android Attendance App for Tea Garden",
        "Tea Garden Worker Attendance App",
        "Tea Garden Employee Attendance App",
        "Tea Garden Android App",
        "Worker Attendance App",
        "Employee Attendance App",
        "Plucking Weighment Software",
        "Green Leaf Weighment Software",
        "Weight Machine Integration Software",
        "Tea Garden Weight Machine Software",
        "Green Leaf Register Software",
        "Tea Garden Field Automation Software",
      ],
    },
    {
      title: "Inventory, Purchase & Consumption",
      text:
        "TeaSof connects inventory, stock, purchase, indent, consumption and product movement reports for better garden cost control and store management.",
      terms: [
        "Tea Garden Inventory Software",
        "Tea Estate Stock Management Software",
        "Tea Garden Stock Management Software",
        "Product Stock Summary Software",
        "Slow Moving Stock Report Software",
        "High Value Stock Report Software",
        "Tea Garden Purchase Management Software",
        "Indent Register Software",
        "Purchase Order Management Software",
        "Pending Purchase Order Software",
        "Tea Garden Consumption Analysis",
        "Tea Estate Consumption Management",
        "SOE Wise Consumption Software",
        "Department Wise Consumption Software",
        "Purpose Wise Consumption Software",
      ],
    },
    {
      title: "Garden Accounting & Management Reports",
      text:
        "TeaSof supports garden accounting, SOE ledger, cost centre ledger, trial balance, outstanding, purchase register and monthly expenditure reports.",
      terms: [
        "Garden Accounting Software",
        "Tea Estate Accounting Software",
        "Tea Garden Accounting Software",
        "SOE Ledger Software",
        "Cost Centre Ledger Software",
        "Cash Bank Book Software",
        "Journal Book Software",
        "Purchase Register Software",
        "Monthly Expenditure Statement Software",
        "Party Wise Outstanding Software",
        "Trial Balance Software",
        "Tea Garden Management Reports",
        "Tea Estate Financial Accounting Software",
      ],
    },
  ];

  const seoPainPoints = [
    {
      title: "Worker wage calculation made easier",
      text:
        "TeaSof helps tea gardens manage worker wages, daily Kamjari, wage sheets, wage slips, PF, ration, bonus, arrear and leave registers with organized payroll reports.",
    },
    {
      title: "Android attendance for field operations",
      text:
        "TeaSof supports Android attendance for workers and employees so tea estates can reduce manual attendance register work and improve daily field reporting accuracy.",
    },
    {
      title: "Stock, purchase and consumption control",
      text:
        "TeaSof connects inventory, purchase, indent, product movement, department consumption, SOE consumption and purpose-wise consumption for better garden cost control.",
    },
    {
      title: "Complete garden accounting reports",
      text:
        "TeaSof provides cash bank book, journal book, ledger, SOE ledger, cost centre ledger, outstanding statement, monthly expenditure and trial balance reports.",
    },
  ];

  const faqList = [
    {
      question: "What is TeaSof tea garden management software?",
      answer:
        "TeaSof is a complete tea garden ERP software designed for tea estates to manage worker wages, staff salary, attendance, Kamjari, inventory, purchase, consumption, garden accounting and management reports.",
    },
    {
      question: "Does TeaSof support worker wages and Kamjari?",
      answer:
        "Yes. TeaSof supports casual, permanent and contractual worker attendance, wage sheet, summary wage, worker wage slip, daily Kamjari, worker wise Kamjari, division wise Kamjari, PF, bonus, ration and leave registers.",
    },
    {
      question: "Can TeaSof manage Android attendance and weight machine integration?",
      answer:
        "Yes. TeaSof supports Android attendance for worker and employee attendance and can be integrated with weight machine systems for plucking weighment and green leaf related field operations.",
    },
    {
      question: "Does TeaSof include inventory, purchase and consumption reports?",
      answer:
        "Yes. TeaSof includes inventory control, product stock summary, slow moving stock, high value stock, purchase analysis, indent register, purchase order register and product, division, department, SOE and purpose wise consumption analysis.",
    },
    {
      question: "Is TeaSof useful for tea garden accounting?",
      answer:
        "Yes. TeaSof provides tea garden accounting reports such as cash bank book, journal book, purchase register, SOE ledger, cost centre ledger, ledger summary, monthly expenditure statement, outstanding report and trial balance.",
    },
  ];

  const siteUrl = (process.env.REACT_APP_SITE_URL || "https://ebssoftware.co.in").replace(/\/$/, "");
  const pagePath = "/TeaSof";
  const pageUrl = `${siteUrl}${pagePath}`;
  const heroImageUrl = String(web5 || "").startsWith("http") ? web5 : `${siteUrl}${web5}`;

  const seoTitle =
    "Tea Garden Management Software | TeaSof ERP for Wages, Attendance, Stock & Accounting";

  const seoDescription =
    "TeaSof is a complete tea garden management software and tea estate ERP for worker wages, Kamjari, Android attendance, staff salary, inventory, purchase, consumption, PF, bonus, ration and garden accounting reports.";

  const softwareSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "TeaSof",
    alternateName: "TeaSof Tea Garden Management Software",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, Android",
    url: pageUrl,
    image: heroImageUrl,
    description: seoDescription,
    brand: {
      "@type": "Brand",
      name: "TeaSof",
    },
    publisher: {
      "@type": "Organization",
      name: "EBS Software Solution",
      url: siteUrl,
    },
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      description: "Contact EBS Software Solution for TeaSof demo and pricing.",
    },
    featureList: [
      "Tea garden worker wage management",
      "Casual, permanent and contractual worker attendance",
      "Daily Kamjari and worker wise Kamjari reports",
      "Android attendance app for tea garden workers and employees",
      "Plucking weighment and weight machine integration",
      "Staff and sub-staff salary management",
      "PF register, ECR challan, bonus, ration and leave reports",
      "Inventory and product stock management",
      "Purchase analysis, indent register and purchase order register",
      "Consumption analysis by division, department, SOE and purpose",
      "Garden accounting, ledger, cost centre ledger and trial balance",
    ],
    keywords: seoKeywords.join(", "),
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: siteUrl,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "TeaSof Tea Garden Management Software",
        item: pageUrl,
      },
    ],
  };

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="teasof-detail-page">
      <Helmet>
        <meta charSet="utf-8" />

        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords.join(", ")} />

        <link rel="canonical" href={pageUrl} />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="EBS Software Solution" />
        <meta name="language" content="English" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={heroImageUrl} />
        <meta property="og:site_name" content="EBS Software Solution" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={heroImageUrl} />

        <script type="application/ld+json">
          {JSON.stringify([softwareSchema, faqSchema, breadcrumbSchema])}
        </script>
      </Helmet>

      <section className="teasof-hero">
        <img
          className="teasof-hero-bg"
          src={web5}
          alt="TeaSof tea garden management software for tea estate ERP worker wages Android attendance inventory and garden accounting"
          onError={handleImageError}
        />
        <div className="teasof-hero-overlay"></div>

        <Container className="teasof-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="teasof-hero-content">
                <div className="teasof-kicker">Tea Garden ERP Software</div>
                <h1>TeaSof</h1>
                <h2>Complete Tea Garden Management Software for Tea Estates</h2>
                <p>
                  TeaSof is a complete tea garden management software and tea
                  estate ERP solution for worker wages, Kamjari, staff salary,
                  Android attendance, plucking weighment, inventory, purchase,
                  consumption and garden accounting reports from one integrated
                  platform.
                </p>

                <div className="teasof-hero-actions">
                  <a href="#teasof-modules" className="teasof-btn teasof-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="teasof-btn teasof-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="teasof-highlight-card">
                <span>Automation Ready</span>
                <strong>Android Attendance + Weight Machine Integration</strong>
                <p>
                  Worker and employee attendance app with plucking weighment and
                  green leaf weight machine integration for accurate field
                  operations in tea gardens.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasof-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="teasof-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="teasof-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="teasof-section-label">Overview</div>
              <h2 className="teasof-section-title">
                Practical tea estate ERP for daily garden operations
              </h2>
              <p className="teasof-text">
                TeaSof helps tea estates manage daily operational details with
                useful reports and insights. It supports tea garden worker wage
                management, staff and sub-staff salary, factory management,
                garden accounting, garden activity and complete inventory
                control.
              </p>
              <p className="teasof-text">
                Android attendance app support is available for worker and
                employee attendance, and weight machine integration is available
                for plucking weighment. This helps tea gardens reduce manual
                effort, improve field-to-office data accuracy and control estate
                operations more confidently.
              </p>
            </Col>

            <Col lg={6}>
              <div className="teasof-overview-card">
                <h3>TeaSof covers</h3>
                <div className="teasof-overview-grid">
                  <div><span>✓</span><p>Worker Wages</p></div>
                  <div><span>✓</span><p>Staff Salary</p></div>
                  <div><span>✓</span><p>Stock Control</p></div>
                  <div><span>✓</span><p>Purchase</p></div>
                  <div><span>✓</span><p>Consumption</p></div>
                  <div><span>✓</span><p>Garden Accounting</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasof-seo-section">
        <Container>
          <div className="teasof-heading-center">
            <div className="teasof-section-label">Why Tea Gardens Choose TeaSof</div>
            <h2 className="teasof-section-title">
              Tea garden management software built for wages, attendance, stock and accounting
            </h2>
            <p>
              TeaSof is designed for tea gardens, tea estates and tea plantations
              that need better control over worker wages, Kamjari, attendance,
              plucking weighment, inventory, purchase, consumption and garden
              accounting.
            </p>
          </div>

          <Row className="g-4">
            {seoPainPoints.map((item) => (
              <Col lg={3} md={6} key={item.title}>
                <div className="teasof-seo-card">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="teasof-modules-section" id="teasof-modules">
        <Container>
          <div className="teasof-heading-center">
            <div className="teasof-section-label">Key Modules</div>
            <h2 className="teasof-section-title">
              Complete module coverage for tea garden management
            </h2>
            <p>
              TeaSof connects garden workforce, inventory, purchase,
              consumption and accounting reports into one organized tea garden
              ERP management system.
            </p>
          </div>

          <Row className="g-4">
            {coreModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="teasof-module-card">
                  <div className="teasof-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="teasof-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="teasof-list-card">
                <div className="teasof-section-label">Worker Wages</div>
                <h2>Tea garden worker wage and Kamjari management</h2>
                <p className="teasof-list-intro">
                  Manage worker attendance, wage sheet, wage slip, PF, ration,
                  bonus, arrear, leave and Kamjari reports for daily tea garden
                  workforce control.
                </p>
                <ul>
                  {wagesFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="teasof-list-card teasof-list-card-dark">
                <div className="teasof-section-label">Employee Salary</div>
                <h2>Staff and sub-staff salary reports</h2>
                <p className="teasof-list-intro">
                  TeaSof helps manage tea estate staff salary, pay register,
                  pay slip, PF register, professional tax, leave, arrear and
                  bonus records.
                </p>
                <ul>
                  {salaryFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasof-feature-list-section teasof-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="teasof-list-card">
                <div className="teasof-section-label">Stock</div>
                <h2>Tea garden inventory and stock control</h2>
                <p className="teasof-list-intro">
                  Track tea estate product stock, company-wise stock,
                  division-wise stock, slow moving stock, high value stock and
                  minimum or maximum stock levels.
                </p>
                <ul>
                  {stockFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="teasof-list-card">
                <div className="teasof-section-label">Purchase Analysis</div>
                <h2>Purchase, indent and supplier tracking</h2>
                <p className="teasof-list-intro">
                  Analyze tea garden purchase records by product, supplier,
                  company, group, division and month with indent register and
                  purchase order reports.
                </p>
                <ul>
                  {purchaseFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasof-accounting-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="teasof-accounting-title">
                <div className="teasof-section-label">Consumption & Accounting</div>
                <h2 className="teasof-section-title">
                  Consumption analysis and garden accounting reports
                </h2>
                <p>
                  TeaSof gives detailed tea garden consumption reports and
                  garden accounting outputs for better cost control, SOE-wise
                  tracking, department-wise analysis and management reporting.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="teasof-tabbed-grid">
                <div className="teasof-grid-panel">
                  <h3>Consumption Analysis</h3>
                  {consumptionFeatures.map((item) => (
                    <div key={item}><span>✓</span><p>{item}</p></div>
                  ))}
                </div>

                <div className="teasof-grid-panel teasof-grid-panel-dark">
                  <h3>Garden Accounting</h3>
                  {accountingFeatures.map((item) => (
                    <div key={item}><span>✓</span><p>{item}</p></div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="teasof-automation-section">
        <Container>
          <div className="teasof-automation-card">
            <Row className="align-items-center g-4">
              <Col lg={7}>
                <div className="teasof-section-label">Automation</div>
                <h2>Android attendance and plucking weighment integration</h2>
                <p>
                  Available Android app for worker and employee attendance, with
                  weight machine integration for plucking weighment and green
                  leaf weighment. This helps reduce manual effort, increase
                  accuracy and improve field reporting for tea garden
                  operations.
                </p>
              </Col>

              <Col lg={5}>
                <div className="teasof-automation-list">
                  <div><strong>Android App</strong><span>Attendance Management</span></div>
                  <div><strong>Face / Field Ready</strong><span>Employee and Worker Attendance</span></div>
                  <div><strong>Weight Machine</strong><span>Plucking Weighment Integration</span></div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="teasof-faq-section">
        <Container>
          <div className="teasof-heading-center">
            <div className="teasof-section-label">FAQ</div>
            <h2 className="teasof-section-title">
              Questions about TeaSof tea garden ERP software
            </h2>
            <p>
              Important information for tea gardens looking for worker wage,
              attendance, inventory, purchase, consumption and accounting
              software.
            </p>
          </div>

          <div className="teasof-faq-list">
            {faqList.map((item) => (
              <div className="teasof-faq-item" key={item.question}>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <section className="teasof-cta-section">
        <Container>
          <div className="teasof-cta-card">
            <div>
              <span>Ready to automate your tea garden?</span>
              <h2>Use TeaSof for wages, attendance, inventory, purchase and accounting.</h2>
              <p>
                Get a complete tea garden management system with Android
                attendance, Kamjari, worker wages, staff salary, plucking
                weighment, stock, purchase, consumption and garden accounting
                reports.
              </p>
            </div>
            <Link to="/EmailContactForm" className="teasof-btn teasof-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>

      <section className="teasof-corporate-keywords-section">
        <Container>
          <div className="teasof-corporate-keywords-head">
            <div className="teasof-section-label">Related Solutions</div>
            <h2>Tea garden ERP, payroll, attendance, stock and accounting search terms</h2>
            <p>
              TeaSof covers important tea garden and tea estate software
              requirements with professional ERP, wage, Kamjari, attendance,
              weighment, inventory, purchase, consumption and accounting modules.
            </p>
          </div>

          <Row className="g-4">
            {relatedSearchGroups.map((group) => (
              <Col lg={6} key={group.title}>
                <div className="teasof-corporate-keyword-card">
                  <h3>{group.title}</h3>
                  <p>{group.text}</p>

                  <div className="teasof-corporate-keyword-list">
                    {group.terms.map((term) => (
                      <span key={term}>{term}</span>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default TeaSof;